export class PageRequest {
    project?: string;
    query: string;
    page = 1;
    size = 20;
    sortField?: string;
    sortDir?: string;
    projectId?: string;
    branchName?: string;
    status: string;
    dateEnabled?: boolean;
    startDate?: string;
    endDate?: string;

    fromDate: string
    toDate: string

    constructor(page = 1, size = 25, sortField?: string, sortDir?: string) {
        this.page = Math.max(1, page);
        this.size = size;
        if (sortField) {
            this.sortField = sortField;
        }
        if (sortDir) {
            this.sortDir = sortDir;
        }
    }

    getSortDir(sortOrder: number) {
        return (sortOrder !== undefined && sortOrder === -1) ? 'asc' : 'desc';
    }
}
